import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import axios from 'axios';

import AccessPad from '../shared/accessPad';
import UserView from '../shared/userView';
import LoadSpinner from '../shared/loadSpinner';

class Access extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: null,
            key:null,
            error: null,
            loading: false
        }

        this.handleJAuth = this.handleJAuth.bind(this);
        this.updateUID = this.updateUID.bind(this);
        this.submitKey = this.submitKey.bind(this); 
    }

    submitKey(keyId){
        var self = this;
        try {
            this.setState({ loading:true, key: keyId }, () => {    
                var postData = {"userId":self.state.userId, "password":self.state.key };
                axios.post(self.props.baseUrl + "/api/auth/login", postData, {'Content-Type': 'application/json'})
                .then(function(response) {
                    self.handleJAuth(response.data); 
                });
            });
        }
        catch(ex){
            console.log(" [Error] Submitting Key: ", ex);
        }
    }

    updateUID(userId){
        try {
            this.setState({ userId: userId, error: null });
        }
        catch(ex){
            console.log("[Error] updating user: ", ex);
        }
    }

    handleJAuth(res){
        var self = this;
        try {
            if(res.error){
                console.log("JAuth: ", res.error);
                this.setState({ userId: null, key:null, error: "JAuth Error", loading:false });
            }
            else {
                this.setState({ loading: false }, ()=>{
                    //if(res.results.userId) { res.results.lastLogin = Date.now();}
                    
                    self.props.userHandler(res.results, function(){
                        self.props.history.push("/");
                    });
                });
            }
        }
        catch(ex){
            console.log("[Error] with jAuth: ", ex);
        }
    }

    componentDidMount(){}

    render(){        
        return(
            <div className="page-body access">
                <div className="content-body main-access">
                    <div className="page-container">
                        {this.state.error != null && <div className="accessErrorMsg">{this.state.error}</div>}
                        {this.state.loading && <LoadSpinner userClass="base" /> }
                        {(this.state.userId == null ? 
                            <UserView updateUID={this.updateUID}/> : <AccessPad submitKey={this.submitKey} saveTitle={"Login"}/>
                        )}
                    </div>
                </div>
            </div>
        );        
    }
}

export default withRouter(Access);